import React, { useState } from 'react';
import LoginModal from '../login/email_login_modal';
import { getUIState } from '../login/auth_utils';
import { PremiumButton, PremiumIcon } from '../premium/premium-icon-button-ui';

function NavbarTop() {
  const showContact = false;
  const uiState = getUIState();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  console.log(" ui state " + uiState);

  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  return (
    <div className="flex flex-col">
      <nav className="fixed top-0 left-0 z-50 w-full border-b border-slate-200 bg-white/95 px-3 py-2 text-gray-800 shadow-sm backdrop-blur-md md:px-6">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-3">

          {/* Left side */}
          <div className="flex items-center gap-2">
            <a
              href="/"
              className="no-underline rounded-2xl px-2 py-1 text-xl font-extrabold tracking-tight text-slate-900 hover:bg-slate-100 hover:text-blue-700 md:mr-4 md:px-4 md:py-2 md:text-2xl"
            >
              CodeZym
            </a>

            {/* Desktop buttons */}
            <div className="hidden items-center gap-2 md:flex">
              <PremiumButton />

              {false &&
                <a
                  href="https://topmate.io/prashant_priyadarshi/665067"
                  className="no-underline rounded-full px-4 py-2 text-base font-medium text-slate-700 transition hover:bg-slate-100 hover:text-black"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Mock Interview
                </a>
              }

              <a
                href="/"
                className="no-underline rounded-full px-4 py-2 text-base font-medium text-slate-700 transition hover:bg-slate-100 hover:text-black"
              >
                Home
              </a>

              {false &&
                <a
                  href="/dsa"
                  className="no-underline rounded-full px-4 py-2 text-base font-medium text-slate-700 transition hover:bg-slate-100 hover:text-black"
                >
                  DSA Practice
                </a>
              }

              {false &&
                <a
                  href="https://mockgym.com/roadmaps"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="no-underline rounded-full px-4 py-2 text-base font-medium text-slate-700 transition hover:bg-slate-100 hover:text-black"
                >
                  Company Preparation Roadmaps
                </a>
              }

              {false &&
                <a
                  href="https://mockgym.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="no-underline rounded-full px-4 py-2 text-base font-medium text-slate-700 transition hover:bg-slate-100 hover:text-black"
                >
                  AI Mock Interviews
                </a>
              }

              <a
                href="/about"
                className="no-underline rounded-full px-4 py-2 text-base font-medium text-slate-700 transition hover:bg-slate-100 hover:text-black"
              >
                Why CodeZym ?
              </a>

              {showContact &&
                <a
                  href="#"
                  className="no-underline rounded-full px-4 py-2 text-base font-medium text-slate-700 transition hover:bg-slate-100 hover:text-black"
                >
                  Contact
                </a>
              }
            </div>
          </div>

          {/* Right side */}
          <div className="flex items-center gap-2">
            <div className="hidden md:block">
              <LoginModal />
            </div>

            {/* Mobile premium */}
            <PremiumButton className="gap-1.5 px-3 py-1.5 text-sm md:hidden" />

            <div className="md:hidden">
              <LoginModal />
            </div>

            {/* Mobile menu button */}
            <button
              type="button"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-700 shadow-sm hover:bg-slate-50 md:hidden"
              aria-label="Toggle menu"
              aria-expanded={isMobileMenuOpen}
            >
              {isMobileMenuOpen ? (
                <span className="text-2xl leading-none">×</span>
              ) : (
                <span className="flex flex-col gap-1">
                  <span className="block h-0.5 w-5 rounded bg-slate-700" />
                  <span className="block h-0.5 w-5 rounded bg-slate-700" />
                  <span className="block h-0.5 w-5 rounded bg-slate-700" />
                </span>
              )}
            </button>
          </div>
        </div>

        {/* Mobile dropdown */}
        {isMobileMenuOpen && (
          <div className="mx-auto mt-3 max-w-7xl rounded-2xl border border-slate-200 bg-white p-3 shadow-lg md:hidden">
            <div className="grid gap-1">
              <a
                href="/"
                onClick={closeMobileMenu}
                className="no-underline rounded-xl px-4 py-3 text-sm font-semibold text-slate-700 hover:bg-slate-100 hover:text-black"
              >
                Home
              </a>

              <a
                href="/premium"
                onClick={closeMobileMenu}
                className="no-underline flex items-center gap-2 rounded-xl px-4 py-3 text-sm font-semibold text-orange-700 hover:bg-orange-50"
              >
                <PremiumIcon className="h-5 w-5" />
                <span>Premium</span>
              </a>

              <a
                href="/about"
                onClick={closeMobileMenu}
                className="no-underline rounded-xl px-4 py-3 text-sm font-semibold text-slate-700 hover:bg-slate-100 hover:text-black"
              >
                Why CodeZym ?
              </a>

              {false &&
                <a
                  href="https://topmate.io/prashant_priyadarshi/665067"
                  onClick={closeMobileMenu}
                  className="no-underline rounded-xl px-4 py-3 text-sm font-semibold text-slate-700 hover:bg-slate-100 hover:text-black"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Mock Interview
                </a>
              }

              {false &&
                <a
                  href="/dsa"
                  onClick={closeMobileMenu}
                  className="no-underline rounded-xl px-4 py-3 text-sm font-semibold text-slate-700 hover:bg-slate-100 hover:text-black"
                >
                  DSA Practice
                </a>
              }

              {false &&
                <a
                  href="https://mockgym.com/roadmaps"
                  onClick={closeMobileMenu}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="no-underline rounded-xl px-4 py-3 text-sm font-semibold text-slate-700 hover:bg-slate-100 hover:text-black"
                >
                  Company Preparation Roadmaps
                </a>
              }

              {false &&
                <a
                  href="https://mockgym.com/"
                  onClick={closeMobileMenu}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="no-underline rounded-xl px-4 py-3 text-sm font-semibold text-slate-700 hover:bg-slate-100 hover:text-black"
                >
                  AI Mock Interviews
                </a>
              }

              {showContact &&
                <a
                  href="#"
                  onClick={closeMobileMenu}
                  className="no-underline rounded-xl px-4 py-3 text-sm font-semibold text-slate-700 hover:bg-slate-100 hover:text-black"
                >
                  Contact
                </a>
              }
            </div>
          </div>
        )}
      </nav>
    </div>
  );
}

function NavbarWithOnlyHome() {
  return (
    <nav className="fixed top-0 left-0 z-50 w-full border-b border-slate-200 bg-white/95 px-3 py-2 text-gray-800 shadow-sm backdrop-blur-md md:px-6">
      <div className="mx-auto flex max-w-7xl items-center justify-between">
        <a
          href="/"
          className="no-underline rounded-2xl px-2 py-1 text-xl font-extrabold tracking-tight text-slate-900 hover:bg-slate-100 hover:text-blue-700 md:px-4 md:py-2 md:text-3xl"
        >
          CodeZym
        </a>
      </div>
    </nav>
  );
}

export { NavbarTop, NavbarWithOnlyHome };